import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { SubmissionError } from 'redux-form'
import { Row, Col } from 'pui-react-grids'
import Paper from 'material-ui/Paper'
import PasswordRecoverForm from '../common/PasswordRecoverForm'
import { resetPassword } from '../api'

const styles = {
  welcomeCol: {
    textAlign: 'center',
    height: '100%',
    paddingBottom: '40px',
    maxWidth: '500px',
    margin: 'auto',
  },
}

class PasswordRecover extends PureComponent {
  state = {
    sentToUsername: null,
  }

  handleSubmitRecover = ({ username }) => {
    return resetPassword(username).then(() => username).catch(error => {
      const statusCode = get(error, 'response.statusCode')
      if (statusCode === 404) {
        throw new SubmissionError({
          username: "L'username inserito è invalido",
        })
      }
      return Promise.reject(error)
    })
  }

  handleRecoverSuccess = username => {
    this.setState({ sentToUsername: username })
  }

  render() {
    return (
      <Row style={{ marginLeft: 0, marginRight: 0 }}>
        <Col md={7} />
        <Col md={10} style={styles.welcomeCol}>
          <Paper>
            {!this.state.sentToUsername &&
              <PasswordRecoverForm
                onSubmit={this.handleSubmitRecover}
                onSubmitSuccess={this.handleRecoverSuccess}
              />}
            {this.state.sentToUsername &&
              <div style={{ padding: 30 }}>
                Password resettata con successo, controlla la casella mail
                dell'account {this.state.sentToUsername} e apri il link al suo
                interno per completare l'operazione.
              </div>}
          </Paper>
        </Col>
        <Col md={7} />
      </Row>
    )
  }
}

export default PasswordRecover



// WEBPACK FOOTER //
// ./src/pages/PasswordRecover.js